import React, { useState, useEffect } from "react";

import './../PopUp.css';
import './UpdateSite.css';

import { RegisterModalData, RegisterModalObserver, SetModalState } from "../../../interface/PopUp";

export default function PopUp_UpdateSite() {

    const [ modalData, setModaldata ] = useState({});
    const [ showPopUp, setShowPopUp ] = useState(false);
    
    function ClosePopUp(){
        SetModalState('UpdateSite', false);
    }
    
    useEffect(()=>{
        RegisterModalData('UpdateSite', setModaldata);
        RegisterModalObserver('UpdateSite', setShowPopUp);
    }, []);      

    return(
        (showPopUp ?
            <div className="PopUp PopUpCenter">

            </div>
        : <React.Fragment></React.Fragment>)
    )
}